import { Skeleton } from "@/app/admin/_common/ui/skeleton";

export default function FestivalDetailsTabSkeleton() {
  return (
    <div className="mx-auto flex w-full max-w-[920px] flex-col gap-6 md:flex-row">
      <div className="min-w-0 flex-1 flex-col gap-4">
        <div className="grid gap-4">
          <div className="grid gap-3">
            <Skeleton className="h-3.5 w-10" />
            <Skeleton className="h-[38px] w-full" />
          </div>
          <div className="grid gap-3">
            <Skeleton className="h-3.5 w-20" />
            <Skeleton className="h-[220px] w-full" />
          </div>
          <div className="grid gap-3">
            <div className="flex items-center justify-between">
              <Skeleton className="h-3.5 w-14" />
              <Skeleton className="h-[26px] w-[90px] rounded-md" />
            </div>
            <div className="flex flex-col gap-1.5">
              {Array.from({ length: 5 }).map((_, i) => (
                <div key={i} className="flex items-center gap-2 rounded-md border border-border px-2.5 py-1.5">
                  <Skeleton className="size-[26px] flex-none rounded-md" />
                  <Skeleton className="h-3 flex-1" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="w-full flex-none md:w-[340px]">
        <div className="flex flex-col gap-3">
          <Skeleton className="h-3.5 w-16" />
          <Skeleton className="aspect-square w-full" />
        </div>
      </div>
    </div>
  );
}
